import { render, staticRenderFns } from "./homeworkDetail.vue?vue&type=template&id=42289a88&scoped=true&"
import script from "./homeworkDetail.vue?vue&type=script&lang=js&"
export * from "./homeworkDetail.vue?vue&type=script&lang=js&"
import style0 from "./homeworkDetail.vue?vue&type=style&index=0&id=42289a88&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42289a88",
  null
  
)

export default component.exports